import { FC } from "react";
import { MembershipType } from "../../enumerations";
import { QESRadioButton } from "@app/shared/qes-standards/forms/RadioButton";
import { QESRadioGroup } from "@app/shared/qes-standards/forms/RadioGroup";

interface SelectMembershipFilterProps {
  disabled: boolean;
  onMembershipTypeChange: (membershipType: MembershipType) => void;
  membershipTypeFilter: MembershipType;
  testIdSuffix: string;
}

const SelectMembershipFilter: FC<SelectMembershipFilterProps> = (props: SelectMembershipFilterProps) => {
  const membershipType = props.membershipTypeFilter;

  return (
    <>
      <p className="lead mb0 demibold">Membership Filter</p>
      <p>Please select the memberships to include:</p>

    <QESRadioGroup groupContainerClass="col-12 mt0">
      <QESRadioButton
        label="Primary Membership"
        disabled={props.disabled}
        value="primary"
        checked={membershipType == MembershipType.Primary}
        onChange={() => { props.onMembershipTypeChange(MembershipType.Primary); }}
        testId={`select-membership-filter__primary--${props.testIdSuffix}`}
      />
      <QESRadioButton
        label="Secondary Membership"
        disabled={props.disabled}
        value="secondary"
        checked={membershipType == MembershipType.Secondary}
        onChange={() => { props.onMembershipTypeChange(MembershipType.Secondary); }}
        testId={`select-membership-filter__secondary--${props.testIdSuffix}`}
      />
      <QESRadioButton
        label="Primary and Secondary Membership Comparison"
        disabled={props.disabled}
        value="both"
        checked={membershipType == MembershipType.Both}
        onChange={() => { props.onMembershipTypeChange(MembershipType.Both); }}
        testId={`select-membership-filter__both--${props.testIdSuffix}`}
      />
      </QESRadioGroup>
    </>
  );
}

export default SelectMembershipFilter;
